import { render, staticRenderFns } from "./ProductFullCharacteristics.vue?vue&type=template&id=195b4389&scoped=true&"
import script from "./ProductFullCharacteristics.vue?vue&type=script&lang=js&"
export * from "./ProductFullCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./ProductFullCharacteristics.vue?vue&type=style&index=0&id=195b4389&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195b4389",
  null
  
)

export default component.exports